import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useNavigate } from "react-router-dom";

function DeliveryBlockModal() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [orders, setOrders] = useState([]);

  // =============================
  // LISTEN GLOBAL EVENT
  // =============================
  useEffect(() => {
    const handleBlock = (e) => {
      const newOrder = {
        orderId: e.detail.orderId,
        customerName: e.detail.customerName,
      };

      setOrders((prev) => {
        const exists = prev.find(
          (o) => o.orderId === newOrder.orderId
        );
        if (exists) return prev;
        return [...prev, newOrder];
      });

      setOpen(true);
    };

    window.addEventListener("deliveryBlockActivated", handleBlock);

    return () =>
      window.removeEventListener("deliveryBlockActivated", handleBlock);
  }, []);

  // =============================
  // CLOSE MODAL
  // =============================
  const handleClose = () => {
    setOpen(false);
    setOrders([]);
  };

  // =============================
  // NAVIGATE TO ORDER
  // =============================
  const handleGoToOrder = (orderId) => {
    navigate(`/order-list/${orderId}/ongoing`);
    setOrders((prev) => prev.filter((o) => o.orderId !== orderId));

    if (orders.length === 1) {
      setOpen(false);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
    >
      {/* HEADER (LIKE YOUR WEIGHT STYLE) */}
      <DialogTitle
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          gap: 1,
          bgcolor: theme.palette.mode === "dark" ? "#2d1f00" : "#fff3cd",
          borderBottom: "1px solid #f59e0b",
        })}
      >
        <WarningAmberIcon sx={{ color: "#f59e0b" }} />
        <Typography fontWeight={700} color="#92400e">
          Pending Delivery Status Update
        </Typography>
      </DialogTitle>

      {/* BODY */}
      <DialogContent sx={{ mt: 2 }}>
        <Typography sx={{ mb: 2 }} color="text.secondary">
          The following orders have passed their delivery slot time.
          Please update status to <b>Delivered</b>.
        </Typography>

        <Box display="flex" flexDirection="column" gap={1}>
          {orders.map((order) => (
            <Box
              key={order.orderId}
              sx={(theme) => ({
                border: "1px solid #f59e0b",
                borderRadius: 2,
                p: 1.5,
                bgcolor: theme.palette.mode === "dark" ? "#2d1f00" : "#fffbeb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              })}
            >
              <Box>
                <Typography fontWeight={600}>
                  Order #{order.orderId}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {order.customerName}
                </Typography>
              </Box>

              <Chip
                label="Pending"
                size="small"
                sx={(theme) => ({
                  bgcolor: theme.palette.mode === "dark" ? "#3d2a00" : "#fef3c7",
                  color: "#92400e",
                  fontWeight: 600,
                })}
              />
            </Box>
          ))}
        </Box>
      </DialogContent>

      {/* ACTION */}
      <DialogActions sx={{ p: 2 }}>
        {orders.map((order) => (
          <Button
            key={order.orderId}
            variant="contained"
            color="warning"
            onClick={() => handleGoToOrder(order.orderId)}
            sx={{ fontWeight: 700 }}
          >
            Go to Order #{order.orderId}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}

export default DeliveryBlockModal;